import type { ReactNode } from "react";
import type { SubmittedDatasetRef } from "@/api/training";
import { openDatasetDetailWindow } from "@/app/datasetDetailWindow";
import styles from "./AnnotationSetMark.module.css";

/**
 * 배경 분리에 어노테이션 세트를 쓴 입력의 표식.
 *
 * 세트 **이름은 표시하지 않는다**(사용자 확정). 이름을 표시하려면 입력마다 세트를 한 번씩 조회해야
 * 하고, 삭제된 세트의 404 도 따로 처리해야 한다. 대신 눌러서 그 세트를 여는 딥링크를 준다.
 *
 * 링크는 **registry 원본이 있을 때만** 준다(`registry_ref`). 원본이 지워진 입력은 저널에 세트
 * uuid 가 남아 있어도 열 화면이 없다. 무엇으로 학습했는지는 표식이 알리고, 그 이상은 저널이
 * 맡는다.
 */
export function AnnotationSetMark({ dataset }: { dataset: SubmittedDatasetRef }): ReactNode {
  const setUuid = dataset.annotation_set_uuid ?? null;
  const ref = dataset.registry_ref ?? null;
  if (setUuid === null) {
    return null;
  }
  if (ref === null) {
    return <span className={styles.mark}>Annotation Set</span>;
  }
  return (
    <button
      type="button"
      className={styles.link}
      onClick={() =>
        openDatasetDetailWindow({
          datasetUuid: ref.uuid,
          displayName: ref.display_name,
          initialTab: "annotation",
          annotationSetUuid: setUuid,
        })
      }
    >
      Annotation Set
    </button>
  );
}
